import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActions = ({
  selectedCount,
  totalCount,
  onSelectAll,
  onBulkResend,
  onClearSelection
}) => {
  const allSelected = selectedCount === totalCount;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {selectedCount > 0 && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 rounded-lg">
          <Icon name="CheckSquare" size={16} className="text-primary" />
          <span className="text-sm font-medium text-primary">
            {selectedCount} selected
          </span>
        </div>
      )}

      <Button
        variant="outline"
        size="sm"
        iconName={allSelected ? 'Square' : 'CheckSquare'}
        iconPosition="left"
        onClick={onSelectAll}
      >
        {allSelected ? 'Deselect All' : 'Select All'}
      </Button>

      {selectedCount > 0 && (
        <>
          <Button
            variant="default"
            size="sm"
            iconName="Send"
            iconPosition="left"
            onClick={onBulkResend}
          >
            Resend ({selectedCount})
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearSelection}
          >
            Clear
          </Button>
        </>
      )}
    </div>
  );
};

export default BulkActions;